const actions = {
  getItemSelect({ commit }) {
    commit("GET_ITEMSELECT");
  },

  setItemSelect({ commit }, itemSelect) {
    commit("SET_ITEMSELECT", itemSelect);
  },

  getFts({ commit }) {
    commit("GET_FTS");
  },

  setFts({ commit }, fts) {
    commit("SET_FTS", fts);
  },
};

export default actions;
